export default [
  {
    path: '/tickets/list/:type',
    name: 'ticketsList',
    component: () => import('@/views/tickets/list'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/tickets/detail',
    name: 'ticketsDetail',
    component: () => import('@/views/tickets/detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/tickets/begin/endorsement',
    name: 'beginEndoresment',
    component: () => import('@/views/tickets/beginEndorsment'),
    meta: {
      keepAlive: false
    }
  },
]
